.formItem {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  & div div,
  & div input {
    height: 60px;
    border-radius: 40px;
    width: 100%;
    display: block;
    padding: 20px 12px 12px 24px;
    font-size: 17px;
    font-weight: 700;
    background: #e4dfd3;
    color: 231e19;
    box-sizing: border-box;
  }
}

:global body.dark {
  :local {

    .formItem {
      & div div,
      & div input {
        background: #181716;
        color: #fffbf2;
      }
    }
  }
}
